import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, Calendar, TrendingUp, Award, Plus, GraduationCap, BookOpen, Trophy, Bell, BarChart } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/Table';
import { useAuth } from '../../contexts/AuthContext';
export function StudentChapterDashboard() {
  const {
    user
  } = useAuth();
  const navigate = useNavigate();
  const stats = [{
    label: 'Anggota Mahasiswa',
    value: '89',
    trend: '+8 bulan ini',
    trendUp: true,
    icon: GraduationCap,
    color: 'text-atios-primary',
    bgColor: 'bg-atios-light'
  }, {
    label: 'Acara Aktif',
    value: '5',
    trend: '2 mendatang',
    trendUp: true,
    icon: Calendar,
    color: 'text-success',
    bgColor: 'bg-success-light'
  }, {
    label: 'Kelompok Belajar',
    value: '12',
    trend: '3 baru minggu ini',
    trendUp: true,
    icon: BookOpen,
    color: 'text-warning',
    bgColor: 'bg-warning-light'
  }, {
    label: 'Kompetisi Dimenangkan',
    value: '3',
    trend: 'Semester ini',
    trendUp: true,
    icon: Trophy,
    color: 'text-neutral-700',
    bgColor: 'bg-neutral-100'
  }];
  const recentMembers = [{
    id: 1,
    name: 'Rina Kusuma',
    studentId: '1806345678',
    major: 'Ilmu Komputer',
    joinDate: '2 hari lalu',
    status: 'active'
  }, {
    id: 2,
    name: 'Dimas Pratama',
    studentId: '1806456789',
    major: 'Sistem Informasi',
    joinDate: '5 hari lalu',
    status: 'active'
  }, {
    id: 3,
    name: 'Ayu Lestari',
    studentId: '1806567890',
    major: 'Rekayasa Perangkat Lunak',
    joinDate: '1 minggu lalu',
    status: 'pending'
  }];
  const upcomingEvents = [{
    id: 1,
    title: 'Workshop Pengembangan Web',
    date: '18 Jan 2025',
    registered: 25,
    capacity: 30,
    type: 'Workshop'
  }, {
    id: 2,
    title: 'Persiapan Hackathon',
    date: '25 Jan 2025',
    registered: 18,
    capacity: 20,
    type: 'Kompetisi'
  }, {
    id: 3,
    title: 'Kelompok Belajar: Algoritma',
    date: '20 Jan 2025',
    registered: 12,
    capacity: 15,
    type: 'Belajar'
  }];
  return <div className="min-h-screen bg-white" data-id="element-1548">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8" data-id="element-1549">
        {/* Header */}
        <div className="flex items-center justify-between" data-id="element-1550">
          <div data-id="element-1551">
            <div className="flex items-center gap-3 mb-2" data-id="element-1552">
              <h1 className="text-3xl font-semibold text-neutral-900" data-id="element-1553">
                Dasbor Student Chapter
              </h1>
              <Badge className="bg-atios-primary text-white font-semibold" data-id="element-1554">
                MAHASISWA
              </Badge>
            </div>
            <p className="text-neutral-600" data-id="element-1555">
              {user?.chapterName || 'Student Chapter'} -{' '}
              {user?.university || 'Universitas Indonesia'}
            </p>
          </div>
          <div className="flex gap-3" data-id="element-1556">
            <Button variant="secondary" onClick={() => navigate('/chapter/study-groups')} data-id="element-1557">
              <BookOpen className="w-4 h-4 mr-2" data-id="element-1558" />
              Kelompok Belajar
            </Button>
            <Button onClick={() => navigate('/events/create')} data-id="element-1559">
              <Plus className="w-4 h-4 mr-2" data-id="element-1560" />
              Buat Acara
            </Button>
          </div>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1561">
          {stats.map((stat, i) => <Card key={i} data-id="element-1562">
              <CardContent className="p-6" data-id="element-1563">
                <div className="flex justify-between items-start mb-4" data-id="element-1564">
                  <div className={`p-3 rounded-lg ${stat.bgColor}`} data-id="element-1565">
                    <stat.icon className={`w-6 h-6 ${stat.color}`} data-id="element-1566" />
                  </div>
                  {stat.trendUp && <TrendingUp className="w-4 h-4 text-success" data-id="element-1567" />}
                </div>
                <div className="space-y-1" data-id="element-1568">
                  <h3 className="text-2xl font-semibold text-neutral-900" data-id="element-1569">
                    {stat.value}
                  </h3>
                  <p className="text-sm text-neutral-600" data-id="element-1570">{stat.label}</p>
                </div>
                <p className="text-xs mt-3 text-success" data-id="element-1571">{stat.trend}</p>
              </CardContent>
            </Card>)}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1572">
          {/* Recent Student Members */}
          <Card data-id="element-1573">
            <CardHeader className="flex flex-row items-center justify-between" data-id="element-1574">
              <CardTitle data-id="element-1575">Anggota Mahasiswa Terbaru</CardTitle>
              <Button variant="link" className="text-atios-primary" onClick={() => navigate('/chapter/members')} data-id="element-1576">
                Lihat Semua
              </Button>
            </CardHeader>
            <CardContent data-id="element-1577">
              <Table data-id="element-1578">
                <TableHeader data-id="element-1579">
                  <TableRow data-id="element-1580">
                    <TableHead data-id="element-1581">Nama</TableHead>
                    <TableHead data-id="element-1582">NIM</TableHead>
                    <TableHead data-id="element-1583">Jurusan</TableHead>
                    <TableHead data-id="element-1584">Status</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody data-id="element-1585">
                  {recentMembers.map(member => <TableRow key={member.id} data-id="element-1586">
                      <TableCell data-id="element-1587">
                        <div data-id="element-1588">
                          <p className="font-medium text-neutral-900" data-id="element-1589">
                            {member.name}
                          </p>
                          <p className="text-xs text-neutral-500" data-id="element-1590">
                            {member.joinDate}
                          </p>
                        </div>
                      </TableCell>
                      <TableCell className="text-neutral-600" data-id="element-1591">
                        {member.studentId}
                      </TableCell>
                      <TableCell className="text-neutral-600" data-id="element-1592">
                        {member.major}
                      </TableCell>
                      <TableCell data-id="element-1593">
                        <Badge variant={member.status === 'active' ? 'success' : 'warning'} data-id="element-1594">
                          {member.status === 'active' ? 'AKTIF' : 'MENUNGGU'}
                        </Badge>
                      </TableCell>
                    </TableRow>)}
                </TableBody>
              </Table>
            </CardContent>
          </Card>

          {/* Upcoming Activities */}
          <Card data-id="element-1595">
            <CardHeader className="flex flex-row items-center justify-between" data-id="element-1596">
              <CardTitle data-id="element-1597">Aktivitas Mendatang</CardTitle>
              <Button variant="link" className="text-atios-primary" onClick={() => navigate('/events')} data-id="element-1598">
                Lihat Semua
              </Button>
            </CardHeader>
            <CardContent data-id="element-1599">
              <div className="space-y-4" data-id="element-1600">
                {upcomingEvents.map(event => <div key={event.id} className="flex items-center justify-between p-4 rounded-lg border border-neutral-200 hover:border-atios-primary transition-all cursor-pointer" onClick={() => navigate(`/events/${event.id}`)} data-id="element-1601">
                    <div className="flex-1" data-id="element-1602">
                      <div className="flex items-center gap-2 mb-1" data-id="element-1603">
                        <h4 className="font-medium text-neutral-900" data-id="element-1604">
                          {event.title}
                        </h4>
                        <Badge variant="default" className="text-xs" data-id="element-1605">
                          {event.type}
                        </Badge>
                      </div>
                      <p className="text-sm text-neutral-600" data-id="element-1606">{event.date}</p>
                    </div>
                    <div className="text-right" data-id="element-1607">
                      <p className="text-sm font-medium text-neutral-900" data-id="element-1608">
                        {event.registered}/{event.capacity}
                      </p>
                      <p className="text-xs text-neutral-500" data-id="element-1609">terdaftar</p>
                    </div>
                  </div>)}
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Quick Actions */}
        <div data-id="element-1610">
          <h2 className="text-lg font-semibold text-neutral-900 mb-4" data-id="element-1611">
            Aksi Cepat
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4" data-id="element-1612">
            {[{
            label: 'Tambah Mahasiswa',
            icon: GraduationCap,
            onClick: () => navigate('/chapter/members/add')
          }, {
            label: 'Buat Kelompok Belajar',
            icon: BookOpen,
            onClick: () => navigate('/chapter/study-groups/create')
          }, {
            label: 'Jadwalkan Acara',
            icon: Calendar,
            onClick: () => navigate('/events/create')
          }, {
            label: 'Lihat Laporan',
            icon: BarChart,
            onClick: () => navigate('/chapter/reports')
          }].map((action, i) => <Button key={i} variant="secondary" className="h-auto py-4 flex flex-col gap-2 hover:border-atios-primary transition-all" onClick={action.onClick} data-id="element-1613">
                <action.icon className="w-5 h-5" data-id="element-1614" />
                <span className="text-sm" data-id="element-1615">{action.label}</span>
              </Button>)}
          </div>
        </div>
      </div>
    </div>;
}